/* RESPONSIBLE TEAM: team-ai-insights */

import { get } from 'embercom/lib/ajax';

export enum TrendingTopicImpact {
  Positive = 0,
  Negative = 1,
  Neutral = 2,
  Unknown = 3,
}

export enum TrendingTopicTimeTrend {
  IncreasingTrend = 0,
  DecreasingTrend = 1,
  Flat = 2,
  SingleWeekAnomaly = 3,
  Unknown = 4,
}

export interface TrendingTopic {
  subtopicName: string;
  topicName: string;
  timeTrend: TrendingTopicTimeTrend;
  weekStart: string;
  impact: TrendingTopicImpact;
  primaryMetric: string;
  insightTitle: string;
  insightPreview: string;
  insightExplanation: string;
  outlierConversationIds: string[];
}

export interface TrendingTopicWireFormat {
  subtopic_name: string;
  topic_name: string;
  time_trend: number;
  week_start: string;
  impact: number;
  primary_metric: string;
  insight_title: string;
  insight_preview: string;
  insight_explanation: string;
  outlier_conversation_ids: string[];
}

async function fetchTrendingTopics(
  appId: any,
  syntheticDataUseCase: string | null,
  signal?: AbortSignal,
  weekStart?: string,
) {
  try {
    let response = (await get(
      '/ember/ai_insights/trending_topics',
      {
        app_id: appId,
        synthetic_data_use_case: syntheticDataUseCase,
        week_start: weekStart,
      },
      { signal },
    )) as TrendingTopicWireFormat[];

    if (response.length === 0) {
      return [];
    }

    return response.map((topic) => ({
      subtopicName: topic.subtopic_name,
      topicName: topic.topic_name,
      timeTrend: topic.time_trend,
      weekStart: topic.week_start,
      impact: topic.impact,
      primaryMetric: topic.primary_metric,
      insightTitle: topic.insight_title,
      insightPreview: topic.insight_preview,
      insightExplanation: topic.insight_explanation,
      outlierConversationIds: topic.outlier_conversation_ids,
    }));
  } catch (error) {
    return [];
  }
}

async function fetchAvailableWeekStarts(appId: any) {
  try {
    let response = (await get('/ember/ai_insights/trending_topics_available_week_starts', {
      app_id: appId,
    })) as { week_starts: string[] };

    let sortedWeekStarts = response.week_starts.sort(
      (a, b) => new Date(b).getTime() - new Date(a).getTime(),
    );
    return sortedWeekStarts;
  } catch (error) {
    return [];
  }
}

export { fetchTrendingTopics, fetchAvailableWeekStarts };
